import * as Mamba from '@mamba/clients';
import lodash from 'lodash';
import Vue from 'vue';
import { $AppConfig } from './global';
export const Store = Mamba.createStore();
// 全局状态
Object.defineProperty(Vue.prototype, '$Store', {
    get: lodash.constant(Store),
});
lodash.set(Vue, '$Store', Store);
Mamba.Log.success('【 Global 】', $AppConfig, Store, Mamba);
